import React from "react";
import { get as _get } from "lodash";
import SETTINGS from "../../../settings";

export default class StaticCornerMap extends React.PureComponent {
  constructor(props) {
    super(props);

    this.img_width = window.innerWidth > 1000 ? 1000 : window.innerWidth;
    this.img_height = window.innerWidth < 768 ? 250 : this.img_width * 1.1;
  }

  getUrl = () => {
    let { lat, lng } = this.props;

    let pinLat, pinLng, centerLat, centerLng;
    pinLat = lat;
    pinLng = lng;

    if (window.innerWidth <= 768) {
      centerLat = lat;
      centerLng = lng;
    } else {
      centerLat = lat + 0.0008;
      centerLng = lng - 0.001;
    }

    let staticMapRetrieveUrl = `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static/pin-l+A0DF00(${pinLng},${pinLat})/${centerLng},${centerLat},17/${Math.floor(
      this.img_width
    )}x${Math.floor(this.img_height)}?access_token=${SETTINGS.mapboxToken}`;
    return staticMapRetrieveUrl;
  };

  render() {
    return (
      <div
        className={"corner-map-wrapper"}
        style={{ width: this.img_width, height: this.img_height, ...(this.props.style || {}) }}
      >
        <img
          className={"round-corners-md"}
          src={this.getUrl()}
          alt="Targeted Property"
        />
      </div>
    );
  }
}
